import Component from '../lib/Component'
import gsap from 'gsap'
import * as PIXI from 'pixi.js'

window.PIXI = PIXI

export default class PortfolioList extends Component {
    static selector = '[data-portfolio-list]'

    initialize() {
        this.portfolio = this.$el

        this.DOM = {
            portfolio: this.$el,
            portfolioItem:
                this.portfolio.querySelectorAll('.js-portfolio-item'),
            portfolioItemStage: this.portfolio.querySelectorAll(
                '.js-anim-portfolio-item',
            ),
            portfolioPreviewList: this.portfolio.querySelector(
                '.js-work-preview-list',
            ),
            portfolioItemImg: this.$$('.js-portfolio-preview'),
            portfolioCanvas: this.portfolio.querySelector(
                '.js-portfolio-canvas',
            ),
            states: {
                activeItem: 'is-active',
            },
        }

        //PIXI stuff
        this.app = null

        //gsap stuff
        this.displacementTimeline = null

        if (this.portfolio !== null) {
            this.portfolioEvents()
            this.portfolioController()

            gsap.set(this.DOM.portfolioItemStage, {
                perspective: 400,
            })

            gsap.timeline()

            gsap.fromTo(
                this.DOM.portfolioItemStage,
                {
                    opacity: 0,
                    y: '50%',
                    skewY: '-2.5deg',
                },
                {
                    opacity: 1,
                    y: 0,
                    skewY: 0,
                    duration: 0.8,
                    ease: 'expo.out',
                    stagger: 0.1,
                },
            )
        } else {
            console.error(`${this.DOM.portfolio} does not exist in the DOM!`)
        }
    }

    portfolioEvents() {
        for (let i = 0; i < this.DOM.portfolioItem.length; i++) {
            this.DOM.portfolioItem[i].addEventListener('mousemove', (ev) => {
                this.portfolioMousemove(ev)
            })

            this.DOM.portfolioItem[i].addEventListener('mouseenter', (ev) => {
                this.portfolioItemMouseenter(i + 1) // why +1? Hint: PIXI related

                const currentTarget = ev.currentTarget
                for (let j = 0; j < this.DOM.portfolioItem.length; j++) {
                    if (this.DOM.portfolioItem[j] !== currentTarget) {
                        // Perform action on other items here
                        gsap.to(this.DOM.portfolioItem[j], {
                            opacity: 0.3,
                            duration: 0.4,
                            ease: 'power3.out',
                        })
                    }
                }
            })

            this.DOM.portfolioItem[i].addEventListener('mouseleave', (ev) => {
                this.portfolioItemMouseleave()

                const currentTarget = ev.currentTarget
                for (let j = 0; j < this.DOM.portfolioItem.length; j++) {
                    if (this.DOM.portfolioItem[j] !== currentTarget) {
                        // Perform action on other items here
                        gsap.to(this.DOM.portfolioItem[j], {
                            opacity: 1,
                            duration: 0.4,
                            ease: 'power3.out',
                        })
                    }
                }
            })
        }
    }

    portfolioController() {
        // predefine canvas element dimensions in px 16:9
        const canvasWidth = 1280
        const canvasHeight = 525

        this.app = new PIXI.Application({
            width: canvasWidth,
            height: canvasHeight,
            backgroundAlpha: 0,
        })

        // add PIXI canvas element to our DOM element
        this.DOM.portfolioCanvas.appendChild(this.app.view)

        const displacementMapFile = this.DOM.portfolioCanvas.getAttribute(
            'data-displacement-map',
        )

        // create displacement texture
        const displacementMap = PIXI.Sprite.from(displacementMapFile)

        // create PIXI displacement filter and pass the texture
        const displacementFilter = new PIXI.DisplacementFilter(displacementMap)

        // set displacement texture properties
        displacementMap.name = displacementMapFile
        displacementMap.anchor.set(0.5)
        displacementMap.scale.set(1)
        displacementMap.width = canvasWidth
        displacementMap.height = canvasHeight
        displacementMap.position.set(canvasWidth / 2, canvasHeight / 2)

        // set stage properties for filter
        this.app.stage.filterArea = this.app.screen
        this.app.stage.filters = [displacementFilter]

        // add filter to root container/stage
        this.app.stage.addChild(displacementMap)

        // load images from DOM to PIXI container
        for (let i = 0; i < this.DOM.portfolioItem.length; i++) {
            //create texture
            const imageFile = this.DOM.portfolioItemImg[i].getAttribute(
                'data-portfolio-image',
            )

            const texture = PIXI.Texture.from(imageFile)

            // create sprite and pass the texture
            const image = new PIXI.Sprite(texture)

            //set sprites properties
            image.name = imageFile
            image.alpha = 0
            image.width = canvasWidth
            image.height = canvasHeight

            // add sprites to root container/stage
            this.app.stage.addChild(image)
        }

        // DISPLACE TIMELINE
        this.displacementTimeline = gsap.timeline({
            paused: true,
        })

        const canvasElement = this.DOM.portfolioCanvas.querySelector('canvas')

        this.displacementTimeline
            .add('start')
            .fromTo(
                canvasElement,
                {
                    autoAlpha: 0,
                },
                {
                    duration: 0.4,
                    autoAlpha: 1,
                    ease: 'power3.out',
                },
                'start',
            )
            .fromTo(
                canvasElement,
                {
                    scale: 1.5,
                },
                {
                    duration: 0.8,
                    scale: 1,
                    ease: 'power3.out',
                },
                'start',
            )
            .fromTo(
                displacementFilter.scale,
                {
                    x: 150,
                    y: 150,
                },
                {
                    duration: 1.6,
                    x: 0,
                    y: 0,
                    ease: 'power3.out',
                    onComplete: () => {},
                },
                'start',
            )
    }

    portfolioMousemove(ev) {
        const decimalX = ev.clientX / window.innerWidth - 0.5
        const decimalY = ev.clientY / window.innerHeight - 0.5

        gsap.to(this.DOM.portfolioCanvas, {
            duration: 0.4,
            x: 50 * decimalX,
            y: 90 * decimalY,
            ease: 'power3.out',
        })
    }

    portfolioItemMouseenter(index) {
        gsap.to(this.app.stage.children[index], {
            duration: 0.4,
            alpha: 1,
            ease: 'power3.out',
            onStart: () => {
                this.displacementTimeline.restart().pause()
                this.displacementTimeline.play()
            },
        })
    }

    portfolioItemMouseleave() {
        gsap.to(this.app.stage.children, {
            duration: 0.4,
            alpha: 0,
            ease: 'power3.out',
        })
    }
}
